var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[(item.isLink)?_c('router-link',{attrs:{"to":{
                name: 'item',
                params: {
                    id: item.encodedId
                }
            }}},[_vm._v(" "+_vm._s(item.label)+" ")]):_c('span',[_vm._v(_vm._s(item.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }